import { EMPTY_STRING } from '../../../constants/common'
import { getPortalAvatarText } from '../RentalPortal.utils'

// TODO: the mock serves `source` as a Locize key while the endpoint contract is
// still open; translating covers both shapes, since i18next echoes a plain
// display name back unchanged.
export function getRentalPortalApplicantPortalLabel({ applicant, t }) {
  return applicant?.source ? t(applicant.source) : EMPTY_STRING
}

export function getRentalPortalApplicantPortalAvatarProps({ applicant, t }) {
  const label = getRentalPortalApplicantPortalLabel({ applicant, t })

  return {
    alt: label,
    src: applicant?.source_logo_url,
    text: getPortalAvatarText(label),
  }
}
